import api from './api';
import type { Partner, PaginatedResponse } from '../types';

interface ListPartnersParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
}

interface CreatePartnerInput {
  userId: string;
  name: string;
  phone?: string;
  address?: string;
  ownerId?: string;
}

export interface LinkablePartnerUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

interface UpdatePartnerInput {
  name?: string;
  email?: string;
  phone?: string;
  address?: string;
  ownerId?: string | null;
  isActive?: boolean;
}

export async function listPartners(params: ListPartnersParams = {}): Promise<PaginatedResponse<Partner>> {
  const response = await api.get<PaginatedResponse<Partner>>('/partners', { params });
  return response.data;
}

export async function getPartner(id: string): Promise<Partner> {
  const response = await api.get<Partner>(`/partners/${id}`);
  return response.data;
}

export async function getLinkablePartnerUsers(): Promise<LinkablePartnerUser[]> {
  const response = await api.get<LinkablePartnerUser[]>('/partners/linkable-users');
  return response.data;
}

export async function createPartner(data: CreatePartnerInput): Promise<Partner> {
  const response = await api.post<Partner>('/partners', data);
  return response.data;
}

export async function updatePartner(id: string, data: UpdatePartnerInput): Promise<Partner> {
  const response = await api.put<Partner>(`/partners/${id}`, data);
  return response.data;
}

export async function deletePartner(id: string): Promise<void> {
  await api.delete(`/partners/${id}`);
}
